import { BaseControlDirective } from 'app/shared/directives/control/base-control.directive';
import { Component, forwardRef, Injector, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
/* eslint-disable indent */
@Component({
    selector: 'kh-common-checkbox',
    templateUrl: './common-checkbox.component.html',
    styleUrls: ['./common-checkbox.component.less'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CommonCheckboxComponent),
            multi: true
        }],
    standalone: false
})
/* eslint-enable indent */
export class CommonCheckboxComponent extends BaseControlDirective<boolean> {
  @Input() public id = 'common-checkbox';
  @Input() public isClickableLabel = false;

  public constructor(injector: Injector) {
    super(injector);
  }
}
